import { render, staticRenderFns } from "./modalProblemDetail.vue?vue&type=template&id=789902b2&"
import script from "./modalProblemDetail.vue?vue&type=script&lang=js&"
export * from "./modalProblemDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports